export default __webpack_public_path__ + "static/media/bakhe.f44fc798.png";